import * as React from 'react';
import { connect } from 'react-redux';

import { IBranding, IDocument } from '../../infrastructure/interfaces';
import BrandingEditorForm from '../DocumentEditor/BrandingEditorForm';

export interface IBrandingsChoosingProps {
  document: IDocument;
  brandings: IBranding[];
  changeBranding(brand: IBranding): void;
}

export interface IBrandingsChoosingState { }

const mapDispatchToProps = (dispatch: any): any => {
  return {
  };
};

const mapStateToProps = (state: any): any => {
  return {
    document: state.document,
    brandings: state.wizard.brandings,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class BrandingsChoosing extends React.Component<IBrandingsChoosingProps, IBrandingsChoosingState> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            Select branding for front cover:
          </div>
          <div className="stepMessage2">
            You can change this selection later
          </div>
          <div className="stepMessageWarning">
            "Does not apply to Seed Quad Fold Covers"
          </div>
        </div>
        <BrandingEditorForm
          document={this.props.document}
          brandings={this.props.brandings}
          onBrandChange={this.props.changeBranding}
          className="stepContent settingsCropsListContainer--logo"
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Steps/BrandingsChoosing.tsx